var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useContext } from "react";
import { useFormContext } from "react-hook-form";
import { FormFieldGroupContext } from "../FormFieldGroup/FormFieldGroup";
import { GenericFormContext } from "../GenericFormContext";
import { TextArea } from "../../Inputs/TextArea";
import { FormFieldWrapper } from "../FormFieldWrapper";
import { Flex } from "../../Flex";
import { useUniqueId } from "../../../util/useUniqueId";
/**
 *  <br /> <br />
 * ## Description
 * FormTextArea is a component that wraps the react-hook-form `TextArea` component. <br>
 * The value passed to props will be submitted when the form is submitted. <br>
 * It handles form submission and captures user input, providing features like label display,
 * helper text, and optional disabling or read-only mode.
 */
export const FormTextArea = (props) => {
    const { disabled, height, helperText, label, maxLength, multiLine, name, placeholder = "", readOnly, registerProps, required, resize = "both", rows, value, variant, width } = props, rest = __rest(props, ["disabled", "height", "helperText", "label", "maxLength", "multiLine", "name", "placeholder", "readOnly", "registerProps", "required", "resize", "rows", "value", "variant", "width"]);
    const { formState, getFieldState, register } = useFormContext();
    const id = useUniqueId();
    const descriptorId = useUniqueId();
    const { editIsAllowed } = useContext(GenericFormContext);
    const isReadOnly = readOnly === true || editIsAllowed === false;
    const { disabled: disabledFromFormFieldGroup } = React.useContext(FormFieldGroupContext);
    const disabledState = disabledFromFormFieldGroup || disabled;
    const { invalid } = getFieldState(name, formState);
    return (React.createElement(FormFieldWrapper, Object.assign({ "data-testid": `FormField-${name}`, descriptorId: descriptorId, helperText: helperText, label: label, labelHtmlFor: id, multiLine: multiLine, name: name, required: required || Boolean(registerProps === null || registerProps === void 0 ? void 0 : registerProps.required) }, rest),
        React.createElement(Flex, { flexDirection: "row" },
            React.createElement(TextArea, Object.assign({}, register(name, Object.assign({ disabled: disabledState, value }, registerProps)), { "aria-describedby": helperText ? descriptorId : undefined, "data-testid": `FormTextArea-${name}`, "data-trackid": `FormTextArea-${name}`, disabled: disabledState, height: height, id: id, flex: 1, maxLength: maxLength, minWidth: 0, placeholder: placeholder, readOnly: isReadOnly, resize: resize, rows: rows, variant: invalid ? "error" : variant, width: width })))));
};
